import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPic, picState } from '../features/pic/picSlice';
import { sidebarState, unwarp, wrap } from '../features/sidebar/sidebarSlice';
import { Icon } from '@iconify/react';
import { ReactComponent as LogoSiberat } from '../svg/logo.svg';

const Topbar = () => {
  const open = useSelector(sidebarState);
  const pic = useSelector(picState);
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const values = user.data.branchPIC || [];

  const menuIconClick = () => {
    open ? dispatch(wrap()) : dispatch(unwarp());
  };

  const handleChange = value => {
    dispatch(setPic(value));
  };

  return (
    <header className='topbar sticky top-0 z-50 flex items-center h-16 shrink-0 bg-white border-b border-[#E7E7E7] px-4 sm:px-5'>
      <button
        className='topbar__toggle inline-flex items-center justify-center w-10 h-10 rounded-lg text-[#1B2124] hover:bg-[#F6F6F6] transition-colors'
        id='nav-button'
        onClick={menuIconClick}
        type='button'
        aria-label={open ? 'Tutup sidebar' : 'Buka sidebar'}
        aria-expanded={open}
        aria-controls='sidebar'>
        <Icon icon='solar:hamburger-menu-bold' width={22} height={22} />
      </button>

      <div className='ml-auto flex items-center gap-3 min-w-0'>
        {values.length > 0 && (
          <div className='flex items-center gap-2 h-9 px-3 rounded-lg border border-[#E5E7EB] bg-white min-w-0 max-w-[160px] sm:max-w-none'>
            <Icon
              icon='solar:users-group-rounded-bold'
              width={18}
              height={18}
              style={{ color: '#6B7280', flexShrink: 0 }}
            />
            <select
              className='bg-transparent border-0 outline-none text-sm font-medium text-[#1B2124] pr-1 cursor-pointer min-w-0 truncate'
              onChange={event => handleChange(event.target.value)}
              value={pic}
              aria-label='Filter PIC'>
              <option value='null'>Semua Data</option>
              {values.map(row => (
                <option value={row.id} key={row.id}>
                  {row.nama}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className='topbar__brand' title='Siberat' aria-label='Siberat'>
          <LogoSiberat className='topbar__brand-logo' />
        </div>
      </div>
    </header>
  );
};

export default Topbar;
